<div class="page-header" *ngIf="!router.url.includes('dashboard/overview')">
    <p class="mb-2 title">
        <span class="home">HOME</span>
        <span class="">/ {{ desc | uppercase }}</span>
    </p>

    <p class="body m-0">{{ desc }}</p>
</div>

<div class="page-header" *ngIf="router.url.includes('dashboard/overview')">
    <p class="body mb-2">{{ title }}</p>
    <p class="m-0 title font-normal">{{ desc }}</p>
</div>